import React, { Component, PropTypes } from 'react'
import Table from 'react-bootstrap/lib/Table'
import acc from 'accounting'

import { truncate } from 'utils/helpers'

class Data extends Component {

  componentDidMount() {
    // window.print()
  }

  render() {
    const { data, campus } = this.props
    let cont = null
    let back = null
    if (data.get('fees').size > 10) {
      cont = (<tr><td colSpan="3"><em>Continuation at the back...</em></td></tr>)
      back = (
        <div className="back">
          <Table className="receipt-details">
            <tbody>
              {data.get('fees').map((fee, k) => {
                if (k < 11) {
                  return null
                }
                return (
                  <tr key={k}>
                    <td>{truncate(fee.get('fee_name'), 20)}</td>
                    <td>{fee.get('acct_code')}</td>
                    <td className="text-right">{acc.formatNumber(fee.get('amount'), 2)}</td>
                  </tr>
                )
              })}
            </tbody>
          </Table>
        </div>
      )
    }
    return (
      <div id="receipt">
        <div className="front">
          <div className="receipt-header">
            <p className="orno">{data.get('orno')}</p>
            <p className="ordate">{data.get('paydate_string')}</p>
            <p className="orcampus">BISU - {campus}</p>
            <p className="orpayee">{data.get('payee')}</p>
          </div>
          <Table className="receipt-details">
            <tbody>
              <tr>
                <td className="table-buffer" colSpan="3"></td>
              </tr>
              {data.get('fees').map((fee, k) => {
                if (k > 10) {
                  return null
                }
                return (
                  <tr key={k}>
                    <td>{truncate(fee.get('fee_name'), 20)}</td>
                    <td>{fee.get('acct_code')}</td>
                    <td>{acc.formatNumber(fee.get('amount'), 2)}</td>
                  </tr>
                )
              })}
              {cont}
            </tbody>
          </Table>
          <div className="receipt-footer">
            <p colSpan="3" className="total-amount text-right">{acc.formatNumber(data.get('amount'), 2)}</p>
            <p className="text-amount text-left"><small>{data.get('words')}</small></p>
            <p className="cashier text-right"><small>{data.get('cashier_name')}</small></p>
          </div>
        </div>
        {back}
      </div>
    )
  }
}

Data.propTypes = {
  data: PropTypes.object,
  campus: PropTypes.string,
}

export default Data



// WEBPACK FOOTER //
// ./src/containers/Print/Receipt/data.js